import { render, staticRenderFns } from "./ClinicTreatmentCustomers.vue?vue&type=template&id=5eb1795e"
import script from "./ClinicTreatmentCustomers.vue?vue&type=script&lang=js"
export * from "./ClinicTreatmentCustomers.vue?vue&type=script&lang=js"
import style0 from "./ClinicTreatmentCustomers.vue?vue&type=style&index=0&id=5eb1795e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports